import { ActionType } from "../action-types";
import { Action } from "../actions";
import { OperatorDto } from "../../dto/postLogin";

export type ConversationActionType =
  | "transfer"
  | "assign"
  | "block"
  | "unblock"
  | null;

export interface ConversationActionState {
  type: ConversationActionType;
  reason: string;
  operator: OperatorDto | null;
  unlockReasonId: number | null;
}

export const conversationActionInitialState: ConversationActionState = {
  type: null,
  reason: "",
  operator: null,
  unlockReasonId: null,
};

const conversationActionReducer = (
  state: ConversationActionState = conversationActionInitialState,
  action: Action
): ConversationActionState => {
  switch (action.type) {
    case ActionType.SET_CONVERSATION_ACTION: {
      return action.payload as ConversationActionState;
    }

    default:
      return state;
  }
};

export default conversationActionReducer;
